var _style, _g, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127, _defs128, _defs129, _defs130, _defs131, _defs132, _defs133, _defs134, _defs135, _defs136, _defs137, _defs138, _defs139, _defs140, _defs141, _defs142, _defs143, _defs144, _defs145, _defs146, _defs147, _defs148, _defs149, _defs150, _defs151, _defs152, _defs153, _defs154, _defs155, _defs156, _defs157, _defs158, _defs159, _defs160, _defs161, _defs162, _defs163, _defs164, _defs165, _defs166, _defs167, _defs168, _defs169, _defs170, _defs171, _defs172, _defs173, _defs174, _defs175, _defs176, _defs177, _defs178, _defs179, _defs180, _defs181, _defs182, _defs183, _defs184, _defs185, _defs186;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2460f704-7878-43f6-b270-6ee55e0a2793",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133 62",
    style: {
      enableBackground: "new 0 0 133 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.91;}\n\t.st2{clip-path:url(#SVGID_00000064322095478495555390000013602986631674693784_);fill:#008000;}\n\t.st3{clip-path:url(#SVGID_00000083084239754496389540000018103670490816403593_);fill:#008000;}\n\t.st4{clip-path:url(#SVGID_00000138559844569507023050000012916081335201791123_);fill:#008000;}\n\t.st5{clip-path:url(#SVGID_00000037667581244052572280000002682188582879062179_);fill:#008000;}\n\t.st6{clip-path:url(#SVGID_00000173128050232067571840000006420225619346227100_);fill:#008000;}\n\t.st7{clip-path:url(#SVGID_00000043418286903895489730000009805583705293693093_);fill:#008000;}\n\t.st8{clip-path:url(#SVGID_00000072966066412648244670000004701299368840626598_);fill:#008000;}\n\t.st9{clip-path:url(#SVGID_00000048501084866487127160000006296468634328583080_);fill:#008000;}\n\t.st10{clip-path:url(#SVGID_00000169526984239588416910000007904961363324944309_);fill:#008000;}\n\t.st11{clip-path:url(#SVGID_00000142134628938515133460000014190797907260946863_);fill:#008000;}\n\t.st12{clip-path:url(#SVGID_00000029756675854432750480000004292648620966994571_);fill:#008000;}\n\t.st13{clip-path:url(#SVGID_00000005263148995474585080000009286609163138250129_);fill:#008000;}\n\t.st14{clip-path:url(#SVGID_00000165196358471741553260000007437256032082064773_);fill:#008000;}\n\t.st15{clip-path:url(#SVGID_00000093151865441677846320000008494392156917623231_);fill:#008000;}\n\t.st16{clip-path:url(#SVGID_00000104702082877117034670000017374032439973513908_);fill:#008000;}\n\t.st17{clip-path:url(#SVGID_00000021812667366241574730000010772416384094995072_);fill:#008000;}\n\t.st18{clip-path:url(#SVGID_00000092439104632663585190000013455236667383526821_);fill:#008000;}\n\t.st19{clip-path:url(#SVGID_00000058576763413044934150000006610662942047334319_);fill:#008000;}\n\t.st20{clip-path:url(#SVGID_00000159428291698610482580000011595363796671342007_);fill:#008000;}\n\t.st21{clip-path:url(#SVGID_00000042738008820502190580000001994660564073612170_);fill:#008000;}\n\t.st22{clip-path:url(#SVGID_00000167365243385430292730000001310218846173192079_);fill:#008000;}\n\t.st23{clip-path:url(#SVGID_00000170979815774784115930000006849710586775823269_);fill:#008000;}\n\t.st24{clip-path:url(#SVGID_00000049907360042596092000000002237594505346008767_);fill:#008000;}\n\t.st25{clip-path:url(#SVGID_00000039853326573276953430000006945555852237893255_);fill:#008000;}\n\t.st26{clip-path:url(#SVGID_00000109731877295864888470000008643540473611134850_);fill:#008000;}\n\t.st27{clip-path:url(#SVGID_00000041264325973909816680000013209297565664944050_);fill:#008000;}\n\t.st28{clip-path:url(#SVGID_00000034789591992778895960000005193781313072771759_);fill:#008000;}\n\t.st29{clip-path:url(#SVGID_00000125576241007297138690000008057240215659141508_);fill:#008000;}\n\t.st30{clip-path:url(#SVGID_00000145031594934137171190000005684450070292479364_);fill:#008000;}\n\t.st31{clip-path:url(#SVGID_00000146470991080951826510000010356638605611992960_);fill:#008000;}\n\t.st32{clip-path:url(#SVGID_00000096038590991991970340000017147673288967222707_);fill:#008000;}\n\t.st33{clip-path:url(#SVGID_00000073002187394588732650000008950994801081616789_);fill:#008000;}\n\t.st34{clip-path:url(#SVGID_00000120523672827526276190000015165015935353182382_);fill:#008000;}\n\t.st35{clip-path:url(#SVGID_00000114034610622359877590000009349094800714979211_);fill:#008000;}\n\t.st36{clip-path:url(#SVGID_00000134944164522722217520000001319241802661910156_);fill:#008000;}\n\t.st37{clip-path:url(#SVGID_00000168814025393184595820000004246500365419634854_);fill:#008000;}\n\t.st38{clip-path:url(#SVGID_00000025432734492415142110000008630260972168157869_);fill:#008000;}\n\t.st39{clip-path:url(#SVGID_00000022518700794877238590000008375162299397605537_);fill:#008000;}\n\t.st40{clip-path:url(#SVGID_00000093151211011763273900000017701505874323586690_);fill:#008000;}\n\t.st41{clip-path:url(#SVGID_00000134940928599045533160000013080083481862282640_);fill:#008000;}\n\t.st42{clip-path:url(#SVGID_00000078734045633703142560000005684377375800805291_);fill:#008000;}\n\t.st43{clip-path:url(#SVGID_00000054988420943279367780000011858893104978724494_);fill:#008000;}\n\t.st44{clip-path:url(#SVGID_00000078761495368847579280000006460987299968800418_);fill:#008000;}\n\t.st45{clip-path:url(#SVGID_00000013889856684441122520000008365192094428788407_);fill:#008000;}\n\t.st46{clip-path:url(#SVGID_00000101799350961857398620000004915793367546452126_);fill:#008000;}\n\t.st47{clip-path:url(#SVGID_00000135668182340387161690000012417988564426567344_);fill:#008000;}\n\t.st48{clip-path:url(#SVGID_00000077296678372912955150000009484988750071744144_);fill:#008000;}\n\t.st49{clip-path:url(#SVGID_00000104681762146574153310000003492097179934696893_);fill:#008000;}\n\t.st50{clip-path:url(#SVGID_00000164475331057844607180000014934136364629162649_);fill:#008000;}\n\t.st51{clip-path:url(#SVGID_00000062172089866465399210000008490615391488909454_);fill:#008000;}\n\t.st52{clip-path:url(#SVGID_00000085212799253960229640000013648892820626013106_);fill:#008000;}\n\t.st53{clip-path:url(#SVGID_00000124839897581954134960000012119143151958953399_);fill:#008000;}\n\t.st54{clip-path:url(#SVGID_00000121972585289722638590000003732458694112949904_);fill:#008000;}\n\t.st55{clip-path:url(#SVGID_00000011028147978357765470000003318080033253524655_);fill:#008000;}\n\t.st56{clip-path:url(#SVGID_00000117678769387418057680000009879937127482464163_);fill:#008000;}\n\t.st57{clip-path:url(#SVGID_00000107590447988067443610000013752290876737411210_);fill:#008000;}\n\t.st58{clip-path:url(#SVGID_00000075874099336569034450000014880662543362560413_);fill:#116633;}\n\t.st59{clip-path:url(#SVGID_00000160149081504112504690000018040644148719352218_);fill:#116633;}\n\t.st60{clip-path:url(#SVGID_00000157266215429502765230000014124429164685862055_);fill:#116633;}\n\t.st61{clip-path:url(#SVGID_00000056423550859826910590000007089161215242456728_);fill:#116633;}\n\t.st62{clip-path:url(#SVGID_00000008868183464222960920000016411060564255498114_);fill:#116633;}\n\t.st63{clip-path:url(#SVGID_00000075883657000697382120000010052662923195796359_);fill:#116633;}\n\t.st64{clip-path:url(#SVGID_00000129928077798894249810000001446728482204256668_);fill:#116633;}\n\t.st65{clip-path:url(#SVGID_00000155113095709807361850000009340102162481855106_);fill:#116633;}\n\t.st66{clip-path:url(#SVGID_00000173161390865450998590000000717725208210999229_);fill:#116633;}\n\t.st67{clip-path:url(#SVGID_00000041274843195420204100000017322030694087649937_);fill:#116633;}\n\t.st68{clip-path:url(#SVGID_00000084502614382619102270000015083803994308855953_);fill:#116633;}\n\t.st69{clip-path:url(#SVGID_00000179646209764082040550000012403368861677925051_);fill:#116633;}\n\t.st70{clip-path:url(#SVGID_00000114777244640215048640000001150584575490792615_);fill:#116633;}\n\t.st71{clip-path:url(#SVGID_00000003804528662107230190000003849045399540146109_);fill:#116633;}\n\t.st72{clip-path:url(#SVGID_00000155130039404184322240000004393958139290151096_);fill:#116633;}\n\t.st73{clip-path:url(#SVGID_00000064329929997832646150000004755016434046333604_);fill:#116633;}\n\t.st74{clip-path:url(#SVGID_00000100357642525407484080000014267481447414553518_);fill:#116633;}\n\t.st75{clip-path:url(#SVGID_00000089564046683573002180000009728561204432068998_);fill:#116633;}\n\t.st76{clip-path:url(#SVGID_00000088846187744376184790000002881742511407069092_);fill:#116633;}\n\t.st77{clip-path:url(#SVGID_00000009590181018572577480000003488921866728469379_);fill:#116633;}\n\t.st78{clip-path:url(#SVGID_00000061433664168308372490000015340509404866483373_);fill:#116633;}\n\t.st79{clip-path:url(#SVGID_00000174598504655680351350000003545465388314309545_);fill:#116633;}\n\t.st80{clip-path:url(#SVGID_00000013892968130566071280000013296636326410685832_);fill:#116633;}\n\t.st81{clip-path:url(#SVGID_00000062884215721802784030000012081295396973444743_);fill:#116633;}\n\t.st82{clip-path:url(#SVGID_00000142176394281400186670000000994225729217801099_);fill:#116633;}\n\t.st83{clip-path:url(#SVGID_00000017477051380701665400000016985064205908071069_);fill:#116633;}\n\t.st84{clip-path:url(#SVGID_00000153666100521223010850000011926944072155032761_);fill:#116633;}\n\t.st85{clip-path:url(#SVGID_00000183956527148559489650000016164151555893984398_);fill:#116633;}\n\t.st86{clip-path:url(#SVGID_00000078045970683287088790000006944826202650234033_);fill:#116633;}\n\t.st87{clip-path:url(#SVGID_00000008106777852474071550000011405026254690317247_);fill:#116633;}\n\t.st88{clip-path:url(#SVGID_00000170973169446995631980000015243340982136811933_);fill:#116633;}\n\t.st89{clip-path:url(#SVGID_00000178198664549024703390000010784852663896534163_);fill:#116633;}\n\t.st90{clip-path:url(#SVGID_00000035499937640912631990000000010734183358601603_);fill:#116633;}\n\t.st91{clip-path:url(#SVGID_00000030483988747404926680000016235355587925790349_);fill:#116633;}\n\t.st92{clip-path:url(#SVGID_00000014606993591988195700000006527916849288686475_);fill:#116633;}\n\t.st93{clip-path:url(#SVGID_00000083052989706947026270000000681458302471264923_);fill:#116633;}\n\t.st94{clip-path:url(#SVGID_00000092416266940727864130000011641436409862149552_);fill:#116633;}\n\t.st95{clip-path:url(#SVGID_00000169531116319358048290000009815962895844839833_);fill:#116633;}\n\t.st96{clip-path:url(#SVGID_00000101809960665620328840000013905580967359848108_);fill:#116633;}\n\t.st97{clip-path:url(#SVGID_00000074407570607198739770000001950079928110051731_);fill:#116633;}\n\t.st98{clip-path:url(#SVGID_00000075123890107437418950000004633499857030839466_);fill:#116633;}\n\t.st99{clip-path:url(#SVGID_00000159465159885854302010000007410779225151627418_);fill:#116633;}\n\t.st100{clip-path:url(#SVGID_00000003090360749766355200000002361901866983229838_);fill:#116633;}\n\t.st101{clip-path:url(#SVGID_00000060717247933574608580000001727381264255401900_);fill:#116633;}\n\t.st102{clip-path:url(#SVGID_00000155868394181940356730000007204514282224567200_);fill:#116633;}\n\t.st103{clip-path:url(#SVGID_00000178177326950977008140000017032913714938155428_);fill:#116633;}\n\t.st104{clip-path:url(#SVGID_00000137813026952668778490000004306169375731591600_);fill:#116633;}\n\t.st105{clip-path:url(#SVGID_00000103259511467310302210000013417065940861447843_);fill:#116633;}\n\t.st106{clip-path:url(#SVGID_00000062906016111436328020000009021139434038760891_);fill:#116633;}\n\t.st107{clip-path:url(#SVGID_00000085224760422431890740000018415437253072802222_);fill:#116633;}\n\t.st108{clip-path:url(#SVGID_00000145040701525331148920000011578274000724950164_);fill:#116633;}\n\t.st109{clip-path:url(#SVGID_00000115505616945058269110000007053917043322132659_);fill:#116633;}\n\t.st110{clip-path:url(#SVGID_00000170274332592322565670000004635147465771930542_);fill:#116633;}\n\t.st111{clip-path:url(#SVGID_00000019674251412885583340000011374114544810816698_);fill:#116633;}\n\t.st112{clip-path:url(#SVGID_00000083056588010247560530000007936566717534213548_);fill:#116633;}\n\t.st113{clip-path:url(#SVGID_00000040538428913922086710000011738971773220637113_);fill:#116633;}\n\t.st114{clip-path:url(#SVGID_00000095332608081194238580000003494768883448433539_);fill:#116633;}\n\t.st115{clip-path:url(#SVGID_00000062191770674039375180000006258895807387925939_);fill:#116633;}\n\t.st116{clip-path:url(#SVGID_00000079458453902548786810000002882532137917498795_);fill:#116633;}\n\t.st117{clip-path:url(#SVGID_00000129166407366680373810000001488766716184727222_);fill:#116633;}\n\t.st118{clip-path:url(#SVGID_00000051376047111781899410000008779682257987036596_);fill:#116633;}\n\t.st119{clip-path:url(#SVGID_00000148628378840290508530000010790631712961619895_);fill:#116633;}\n\t.st120{clip-path:url(#SVGID_00000097483532854413517920000005729347176698379667_);fill:#116633;}\n\t.st121{clip-path:url(#SVGID_00000026842536581806094870000016342181491736328843_);fill:#116633;}\n\t.st122{clip-path:url(#SVGID_00000062912589809994705510000016477545331750235277_);fill:#116633;}\n\t.st123{clip-path:url(#SVGID_00000161620672543059641200000014091957192089592468_);fill:#116633;}\n\t.st124{clip-path:url(#SVGID_00000181775563864035677530000012414030475389172879_);fill:#116633;}\n\t.st125{clip-path:url(#SVGID_00000176035149593900947030000004798362552317708714_);fill:#116633;}\n\t.st126{clip-path:url(#SVGID_00000063620766336390680580000009474616763058023845_);fill:#116633;}\n\t.st127{clip-path:url(#SVGID_00000074435396853884070500000009960994791080543935_);fill:#116633;}\n\t.st128{clip-path:url(#SVGID_00000001660391025983254340000003259009852571711616_);fill:#116633;}\n\t.st129{clip-path:url(#SVGID_00000096048738207281051230000006137499109233304726_);fill:#116633;}\n\t.st130{clip-path:url(#SVGID_00000150097852434941650830000000156840695555948210_);fill:#116633;}\n\t.st131{clip-path:url(#SVGID_00000106851648234190236860000017896175600830970556_);fill:#116633;}\n\t.st132{clip-path:url(#SVGID_00000090276072743880657880000009762444890863453075_);fill:#116633;}\n\t.st133{clip-path:url(#SVGID_00000092416247469436111220000001169485936784650136_);fill:#116633;}\n\t.st134{clip-path:url(#SVGID_00000132085622292920858910000004501615251166695565_);fill:#116633;}\n\t.st135{clip-path:url(#SVGID_00000037686389636359590270000005797064267142028475_);fill:#116633;}\n\t.st136{clip-path:url(#SVGID_00000112607401394085633970000017062040054807237788_);fill:#116633;}\n\t.st137{clip-path:url(#SVGID_00000074411206703037490550000002154866932898552242_);fill:#116633;}\n\t.st138{clip-path:url(#SVGID_00000020388896194747019290000016386526025476991124_);fill:#116633;}\n\t.st139{clip-path:url(#SVGID_00000152983956078862486920000013168360409489088686_);fill:#116633;}\n\t.st140{clip-path:url(#SVGID_00000151510652867081007700000000795425405078150317_);fill:#116633;}\n\t.st141{clip-path:url(#SVGID_00000171704710490529665200000002718496043369482939_);fill:#116633;}\n\t.st142{clip-path:url(#SVGID_00000132072353141607979550000007599067029110402950_);fill:#116633;}\n\t.st143{clip-path:url(#SVGID_00000161626135143361645720000003865837660763762317_);fill:#116633;}\n\t.st144{clip-path:url(#SVGID_00000075861509144589649660000015869434685294151319_);fill:#116633;}\n\t.st145{clip-path:url(#SVGID_00000151545190038233441650000001272395381334591367_);fill:#116633;}\n\t.st146{clip-path:url(#SVGID_00000004536330599764182250000008276350275255462291_);fill:#116633;}\n\t.st147{clip-path:url(#SVGID_00000154406571899053796470000014420357526601013643_);fill:#116633;}\n\t.st148{clip-path:url(#SVGID_00000018933618747547812710000001387656562112691868_);fill:#116633;}\n\t.st149{clip-path:url(#SVGID_00000088849969701955431380000015507826139926376850_);fill:#116633;}\n\t.st150{clip-path:url(#SVGID_00000083795012211639492600000000117495996209459868_);fill:#116633;}\n\t.st151{clip-path:url(#SVGID_00000021109372228851645300000017707236139055287437_);fill:#116633;}\n\t.st152{clip-path:url(#SVGID_00000098193244688361751230000000456774365829472163_);fill:#116633;}\n\t.st153{clip-path:url(#SVGID_00000143609648451111550970000008293783729613083816_);fill:#116633;}\n\t.st154{clip-path:url(#SVGID_00000035510454931511350620000005324475548765291189_);fill:#116633;}\n\t.st155{clip-path:url(#SVGID_00000049905538003588540860000009650702825839622553_);fill:#116633;}\n\t.st156{clip-path:url(#SVGID_00000130621147061558843350000007977435927925334671_);fill:#116633;}\n\t.st157{clip-path:url(#SVGID_00000057112369056535016100000002162066196729478309_);fill:#116633;}\n\t.st158{clip-path:url(#SVGID_00000109029827592583588230000006923433099092261810_);fill:#116633;}\n\t.st159{clip-path:url(#SVGID_00000098925468419494081060000013793935836172140173_);fill:#116633;}\n\t.st160{clip-path:url(#SVGID_00000104686966686992220150000000070401491291113110_);fill:#116633;}\n\t.st161{clip-path:url(#SVGID_00000155129290767636961140000007153869722424027529_);fill:#116633;}\n\t.st162{clip-path:url(#SVGID_00000158014927797644201420000014653839239471978132_);fill:#116633;}\n\t.st163{clip-path:url(#SVGID_00000057850815178388288820000003609057113158343595_);fill:#116633;}\n\t.st164{clip-path:url(#SVGID_00000027595056306509527750000004380179818318885291_);fill:#116633;}\n\t.st165{clip-path:url(#SVGID_00000064322707169915544320000010604800855807416456_);fill:#116633;}\n\t.st166{clip-path:url(#SVGID_00000042007146952150639640000010197776435477310848_);fill:#116633;}\n\t.st167{clip-path:url(#SVGID_00000051354778575554471750000010224539193347400623_);fill:#116633;}\n\t.st168{clip-path:url(#SVGID_00000081644903021942432300000008977893620514985894_);fill:#116633;}\n\t.st169{clip-path:url(#SVGID_00000157291209381146097500000014981968449330662546_);fill:#116633;}\n\t.st170{clip-path:url(#SVGID_00000054981365006525899080000003253007083512588186_);fill:#116633;}\n\t.st171{clip-path:url(#SVGID_00000117677818594026856490000000629600590378871957_);fill:#116633;}\n\t.st172{clip-path:url(#SVGID_00000000928695967215347890000000405457085465242293_);fill:#116633;}\n\t.st173{clip-path:url(#SVGID_00000101076045502712058580000008462838360683364233_);fill:#116633;}\n\t.st174{clip-path:url(#SVGID_00000178205865855950538880000004147977074487262866_);fill:#116633;}\n\t.st175{clip-path:url(#SVGID_00000008119692554308387770000014950711472008006290_);fill:#116633;}\n\t.st176{clip-path:url(#SVGID_00000174563624152371026980000007867395474072375947_);fill:#116633;}\n\t.st177{clip-path:url(#SVGID_00000082357859779661362320000010335243232457956795_);fill:#116633;}\n\t.st178{clip-path:url(#SVGID_00000009569949467464528570000005269544164182616227_);fill:#116633;}\n\t.st179{clip-path:url(#SVGID_00000005961673901627966570000009787150957735510686_);fill:#116633;}\n\t.st180{clip-path:url(#SVGID_00000154401837222609505150000017225522514540623007_);fill:#116633;}\n\t.st181{clip-path:url(#SVGID_00000107550687206468973120000001713881447079774121_);fill:#116633;}\n\t.st182{clip-path:url(#SVGID_00000054951217795001607990000000030525145237621429_);fill:#116633;}\n\t.st183{clip-path:url(#SVGID_00000147920270157067947730000007471986869070115753_);fill:#116633;}\n\t.st184{clip-path:url(#SVGID_00000045584200757010158200000013470186341550910889_);fill:#116633;}\n\t.st185{clip-path:url(#SVGID_00000059997471111960085650000014055700999587884988_);fill:#116633;}\n\t.st186{clip-path:url(#SVGID_00000181775267057283544220000016863074260196223162_);fill:#116633;}\n\t.st187{clip-path:url(#SVGID_00000183232746087417254820000004795392699199355324_);fill:#116633;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 133,
    height: 62
  }))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-b349b7e8-eaee-4f0a-afc4-0919df87a220"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5 20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5  13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029726462041271567390000005577909186564593597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 18.8,
    style: {
      clipPath: "url(#SVGID_00000029726462041271567390000005577909186564593597_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000062874763130794215840000009420224948871764656_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062874763130794215840000009420224948871764656_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111888206117113474900000018132214973342564771_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062874763130794215840000009420224948871764656_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 19.2,
    style: {
      clipPath: "url(#SVGID_00000111888206117113474900000018132214973342564771_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000019680330869362879710000013670210894563475641_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019680330869362879710000013670210894563475641_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063604774094743803930000007632359435812939703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019680330869362879710000013670210894563475641_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 19.6,
    style: {
      clipPath: "url(#SVGID_00000063604774094743803930000007632359435812939703_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000161620385305179671040000018396127761537166729_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161620385305179671040000018396127761537166729_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026147721283012519790000007267829025012597143_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161620385305179671040000018396127761537166729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 20.1,
    style: {
      clipPath: "url(#SVGID_00000026147721283012519790000007267829025012597143_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158734560403974775840000014425505642019377062_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158734560403974775840000014425505642019377062_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009577397428093841250000004685017837380499108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158734560403974775840000014425505642019377062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 20.5,
    style: {
      clipPath: "url(#SVGID_00000009577397428093841250000004685017837380499108_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000085234306228733166720000017730461754281575043_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085234306228733166720000017730461754281575043_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146459298962079707570000016968111037029548709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085234306228733166720000017730461754281575043_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21,
    style: {
      clipPath: "url(#SVGID_00000146459298962079707570000016968111037029548709_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000100384353549194119040000011688059007859186833_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100384353549194119040000011688059007859186833_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054956393099907914290000008547437407521497521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100384353549194119040000011688059007859186833_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.4,
    style: {
      clipPath: "url(#SVGID_00000054956393099907914290000008547437407521497521_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107587257965357700420000004271971857305363391_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107587257965357700420000004271971857305363391_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183970540556650852410000002986197424276232886_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107587257965357700420000004271971857305363391_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.9,
    style: {
      clipPath: "url(#SVGID_00000183970540556650852410000002986197424276232886_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021098312029662094860000007259792502610393789_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021098312029662094860000007259792502610393789_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169546474878729641490000015896495014949504648_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021098312029662094860000007259792502610393789_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 22.3,
    style: {
      clipPath: "url(#SVGID_00000169546474878729641490000015896495014949504648_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000178187055350635846520000004398151325197703324_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178187055350635846520000004398151325197703324_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112596597823824213520000009668366652558386878_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178187055350635846520000004398151325197703324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 22.7,
    style: {
      clipPath: "url(#SVGID_00000112596597823824213520000009668366652558386878_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000016044645431137696800000013327357379777326736_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016044645431137696800000013327357379777326736_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026153207014930091930000008796334400928789158_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016044645431137696800000013327357379777326736_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 23.2,
    style: {
      clipPath: "url(#SVGID_00000026153207014930091930000008796334400928789158_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000146472504316746249160000005441064164366805154_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146472504316746249160000005441064164366805154_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092457055439681049740000000174752866937036421_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146472504316746249160000005441064164366805154_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000092457055439681049740000000174752866937036421_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000163060136988577000820000013622287552427464849_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163060136988577000820000013622287552427464849_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015354758257142057480000000699416628267035041_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163060136988577000820000013622287552427464849_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 24.1,
    style: {
      clipPath: "url(#SVGID_00000015354758257142057480000000699416628267035041_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000154423086787583474280000014835970638042622624_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154423086787583474280000014835970638042622624_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114772735862475402750000018148789257660257188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154423086787583474280000014835970638042622624_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 24.5,
    style: {
      clipPath: "url(#SVGID_00000114772735862475402750000018148789257660257188_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000042710626206951647900000007218406701955298475_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042710626206951647900000007218406701955298475_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047739924562902157080000014367082385922676612_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042710626206951647900000007218406701955298475_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 25,
    style: {
      clipPath: "url(#SVGID_00000047739924562902157080000014367082385922676612_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000048480783094775828040000016578012435887725698_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048480783094775828040000016578012435887725698_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103962293293489536190000016244642310174864016_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048480783094775828040000016578012435887725698_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 25.4,
    style: {
      clipPath: "url(#SVGID_00000103962293293489536190000016244642310174864016_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000139258101933663766130000011259007953178923660_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139258101933663766130000011259007953178923660_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168810531655742768660000018077313355126768567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139258101933663766130000011259007953178923660_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 25.9,
    style: {
      clipPath: "url(#SVGID_00000168810531655742768660000018077313355126768567_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116924134720470150850000009920559620216651190_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116924134720470150850000009920559620216651190_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082365567155666506730000011935810547133809810_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116924134720470150850000009920559620216651190_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 26.3,
    style: {
      clipPath: "url(#SVGID_00000082365567155666506730000011935810547133809810_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000094611314086143246630000005341204999386625698_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094611314086143246630000005341204999386625698_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036233317831891668130000006137897531863061166_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094611314086143246630000005341204999386625698_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 26.7,
    style: {
      clipPath: "url(#SVGID_00000036233317831891668130000006137897531863061166_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000049905397613972134810000013002742982205301126_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049905397613972134810000013002742982205301126_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056408898382751390740000008547651978884497081_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049905397613972134810000013002742982205301126_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 27.2,
    style: {
      clipPath: "url(#SVGID_00000056408898382751390740000008547651978884497081_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000056400812600093821200000012778674280494303167_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056400812600093821200000012778674280494303167_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014617768647255744770000015765545624110169729_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056400812600093821200000012778674280494303167_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 27.6,
    style: {
      clipPath: "url(#SVGID_00000014617768647255744770000015765545624110169729_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000044883455704228513550000005258264829140840093_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044883455704228513550000005258264829140840093_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111888297291112751900000016735159790629543066_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044883455704228513550000005258264829140840093_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 28.1,
    style: {
      clipPath: "url(#SVGID_00000111888297291112751900000016735159790629543066_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000167370620437099149070000012418531390364659374_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167370620437099149070000012418531390364659374_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168818136857682193260000006734084029234096524_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167370620437099149070000012418531390364659374_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 28.5,
    style: {
      clipPath: "url(#SVGID_00000168818136857682193260000006734084029234096524_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000180350099509419991360000015448312800928705976_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180350099509419991360000015448312800928705976_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155145516482632960550000005477452570215263885_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180350099509419991360000015448312800928705976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 29,
    style: {
      clipPath: "url(#SVGID_00000155145516482632960550000005477452570215263885_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000109031803306946888100000016762131623297524399_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109031803306946888100000016762131623297524399_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123409668113569691390000013184874722193405059_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109031803306946888100000016762131623297524399_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 29.4,
    style: {
      clipPath: "url(#SVGID_00000123409668113569691390000013184874722193405059_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096740735620732087380000008588697131531290785_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096740735620732087380000008588697131531290785_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074413609872269785200000013265838331191203246_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096740735620732087380000008588697131531290785_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 29.9,
    style: {
      clipPath: "url(#SVGID_00000074413609872269785200000013265838331191203246_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000145742618367781901510000013009275257674528905_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145742618367781901510000013009275257674528905_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049944251185813012170000012409657005883635873_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145742618367781901510000013009275257674528905_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 30.3,
    style: {
      clipPath: "url(#SVGID_00000049944251185813012170000012409657005883635873_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000075120077178414395560000017952991351902473884_",
    points: "10.4,29.9 20.5,29.9 12,24.9 12,24.5  20.5,19.6 10.4,19.6 10.4,18.8 22.2,18.8 22.2,19.5 13.1,24.8 22.2,30.1 22.2,30.8 10.4,30.8 10.4,29.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075120077178414395560000017952991351902473884_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166649595077383537580000017238501435494362798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075120077178414395560000017952991351902473884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 30.7,
    style: {
      clipPath: "url(#SVGID_00000166649595077383537580000017238501435494362798_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000175324867299185794540000002546971934491852702_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175324867299185794540000002546971934491852702_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115493992244437519090000002858949143857107844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175324867299185794540000002546971934491852702_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 32.9,
    style: {
      clipPath: "url(#SVGID_00000115493992244437519090000002858949143857107844_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183226575153542917170000011388757915355191469_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183226575153542917170000011388757915355191469_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077313655981552461510000012401373047638567313_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183226575153542917170000011388757915355191469_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 33.3,
    style: {
      clipPath: "url(#SVGID_00000077313655981552461510000012401373047638567313_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091008695725862257510000007291005360357038264_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091008695725862257510000007291005360357038264_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061443546108141592160000002621861408177478818_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091008695725862257510000007291005360357038264_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 33.6,
    style: {
      clipPath: "url(#SVGID_00000061443546108141592160000002621861408177478818_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106112254540387084080000001999691240465512072_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106112254540387084080000001999691240465512072_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065059233622210343440000008648034458017435568_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106112254540387084080000001999691240465512072_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 34,
    style: {
      clipPath: "url(#SVGID_00000065059233622210343440000008648034458017435568_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000063623234391195631480000014782214949557299607_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063623234391195631480000014782214949557299607_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115487522513068644010000016178169812368858274_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063623234391195631480000014782214949557299607_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 34.4,
    style: {
      clipPath: "url(#SVGID_00000115487522513068644010000016178169812368858274_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000041998970282580286240000011973395362030853561_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041998970282580286240000011973395362030853561_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020385339499071442050000017543587471600883585_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041998970282580286240000011973395362030853561_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 34.8,
    style: {
      clipPath: "url(#SVGID_00000020385339499071442050000017543587471600883585_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000133498463755796157160000014898904344456218271_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133498463755796157160000014898904344456218271_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129927819003671745220000001759758181610661017_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133498463755796157160000014898904344456218271_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 35.2,
    style: {
      clipPath: "url(#SVGID_00000129927819003671745220000001759758181610661017_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005260695987213820400000018041873312108243896_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005260695987213820400000018041873312108243896_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059998113178934760220000004459952882996978109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005260695987213820400000018041873312108243896_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 35.6,
    style: {
      clipPath: "url(#SVGID_00000059998113178934760220000004459952882996978109_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007401893421776980090000000945626855214764166_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007401893421776980090000000945626855214764166_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021832966655657439100000000015884220080274058_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007401893421776980090000000945626855214764166_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 35.9,
    style: {
      clipPath: "url(#SVGID_00000021832966655657439100000000015884220080274058_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096761900524011119390000004082473385728486308_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096761900524011119390000004082473385728486308_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099650501836812514880000012795920184197438857_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096761900524011119390000004082473385728486308_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 36.3,
    style: {
      clipPath: "url(#SVGID_00000099650501836812514880000012795920184197438857_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000077293540687626994210000015121743061033075611_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077293540687626994210000015121743061033075611_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178901927384613980000000011930655485176401302_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077293540687626994210000015121743061033075611_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 36.7,
    style: {
      clipPath: "url(#SVGID_00000178901927384613980000000011930655485176401302_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158015219537690239150000004040133951366061957_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158015219537690239150000004040133951366061957_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031197653865235254420000013198829502195966107_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158015219537690239150000004040133951366061957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 37.1,
    style: {
      clipPath: "url(#SVGID_00000031197653865235254420000013198829502195966107_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000006687703564765754820000016049182058410885279_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006687703564765754820000016049182058410885279_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153677324642986152380000014786091971317572263_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006687703564765754820000016049182058410885279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 37.5,
    style: {
      clipPath: "url(#SVGID_00000153677324642986152380000014786091971317572263_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000179635156025448961070000005339401353520457884_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179635156025448961070000005339401353520457884_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078041930970436517600000008695023530292740504_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179635156025448961070000005339401353520457884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 37.9,
    style: {
      clipPath: "url(#SVGID_00000078041930970436517600000008695023530292740504_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000158019812013946937860000010407789842425576605_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158019812013946937860000010407789842425576605_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156546821505186263880000005315752284265103519_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158019812013946937860000010407789842425576605_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 38.2,
    style: {
      clipPath: "url(#SVGID_00000156546821505186263880000005315752284265103519_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000130632853710170787810000011431379418182491795_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130632853710170787810000011431379418182491795_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127745986911099694940000018084130371760036001_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130632853710170787810000011431379418182491795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 38.6,
    style: {
      clipPath: "url(#SVGID_00000127745986911099694940000018084130371760036001_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112604182614646529670000000759698858194795933_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112604182614646529670000000759698858194795933_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174583761105573719160000002373455585737404040_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112604182614646529670000000759698858194795933_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 39,
    style: {
      clipPath: "url(#SVGID_00000174583761105573719160000002373455585737404040_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098912971259898130980000013065418911828894870_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098912971259898130980000013065418911828894870_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158745794665562987280000008213452353638078908_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098912971259898130980000013065418911828894870_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 39.4,
    style: {
      clipPath: "url(#SVGID_00000158745794665562987280000008213452353638078908_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000147197430107788716630000010280877345703879084_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147197430107788716630000010280877345703879084_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109018231925322422580000017738533330463273394_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147197430107788716630000010280877345703879084_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 39.8,
    style: {
      clipPath: "url(#SVGID_00000109018231925322422580000017738533330463273394_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000035526227514940864060000017297035099541771148_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035526227514940864060000017297035099541771148_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091707959880567726620000007418367717312531874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035526227514940864060000017297035099541771148_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 40.2,
    style: {
      clipPath: "url(#SVGID_00000091707959880567726620000007418367717312531874_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000052064284010461759700000004301757509963118781_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052064284010461759700000004301757509963118781_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159446880725328251160000010927989785782151615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052064284010461759700000004301757509963118781_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 40.5,
    style: {
      clipPath: "url(#SVGID_00000159446880725328251160000010927989785782151615_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000107548330050823167940000014253175131733337273_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107548330050823167940000014253175131733337273_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162354707884532381800000017935890689805700024_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107548330050823167940000014253175131733337273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 40.9,
    style: {
      clipPath: "url(#SVGID_00000162354707884532381800000017935890689805700024_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000116209240616613202980000016541159166681805211_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116209240616613202980000016541159166681805211_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108296415875558245010000001273452997029232025_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116209240616613202980000016541159166681805211_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 41.3,
    style: {
      clipPath: "url(#SVGID_00000108296415875558245010000001273452997029232025_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000098186199034028844220000007218025521601207992_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098186199034028844220000007218025521601207992_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160185065596451808640000001770811112971400096_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098186199034028844220000007218025521601207992_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 41.7,
    style: {
      clipPath: "url(#SVGID_00000160185065596451808640000001770811112971400096_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000102538974874153600770000008182608523913990789_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102538974874153600770000008182608523913990789_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029724384864925627360000013362171083327081871_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102538974874153600770000008182608523913990789_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 42.1,
    style: {
      clipPath: "url(#SVGID_00000029724384864925627360000013362171083327081871_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091697969494674369460000014767915933414614440_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091697969494674369460000014767915933414614440_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142139901197767041270000001603527687583763134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091697969494674369460000014767915933414614440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 42.5,
    style: {
      clipPath: "url(#SVGID_00000142139901197767041270000001603527687583763134_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000080204306708194814320000009905281737480909726_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080204306708194814320000009905281737480909726_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059271695348004483640000012701240172087096486_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080204306708194814320000009905281737480909726_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 42.9,
    style: {
      clipPath: "url(#SVGID_00000059271695348004483640000012701240172087096486_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000014611480118715736020000005596543025734990724_",
    points: "14.5,38.5 10.4,38.5 10.4,37.6 14.5,37.6  22.2,32.9 22.2,33.8 15.3,38.1 22.2,42.4 22.2,43.3 14.5,38.5  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014611480118715736020000005596543025734990724_",
    style: {
      overflow: "visible",
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176758910553153992880000002792851323387533969_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014611480118715736020000005596543025734990724_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 43.2,
    style: {
      clipPath: "url(#SVGID_00000176758910553153992880000002792851323387533969_)",
      fill: "#008000"
    },
    width: 11.8,
    height: 0.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106831459821988088520000013512473635767719609_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106831459821988088520000013512473635767719609_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083797646779311429800000010738915962459666324_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106831459821988088520000013512473635767719609_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000083797646779311429800000010738915962459666324_)",
      fill: "#116633"
    },
    width: 0.2,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057865727703485033970000013651179118554331308_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057865727703485033970000013651179118554331308_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039096500883168041740000007198393425272217527_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057865727703485033970000013651179118554331308_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000039096500883168041740000007198393425272217527_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054970322191086311720000007004435819153079738_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054970322191086311720000007004435819153079738_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093143431479738059130000005441407351869258632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054970322191086311720000007004435819153079738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000093143431479738059130000005441407351869258632_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173852171757006516410000002658424046158850442_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173852171757006516410000002658424046158850442_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031176314193791312770000002972085878927029387_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173852171757006516410000002658424046158850442_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000031176314193791312770000002972085878927029387_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163065259270139550460000010196235483722438325_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163065259270139550460000010196235483722438325_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111152854260795214330000015197668548154547127_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163065259270139550460000010196235483722438325_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000111152854260795214330000015197668548154547127_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108294761831732582440000000966231225791815567_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108294761831732582440000000966231225791815567_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000084494592453903865440000007624343061342462102_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108294761831732582440000000966231225791815567_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000084494592453903865440000007624343061342462102_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099633987979125878870000010990824795828323997_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099633987979125878870000010990824795828323997_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173859710551383686530000003088854140825292692_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099633987979125878870000010990824795828323997_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000173859710551383686530000003088854140825292692_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005961979048195372320000013647696089040335536_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005961979048195372320000013647696089040335536_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124845148660806957270000006822255118620346289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005961979048195372320000013647696089040335536_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000124845148660806957270000006822255118620346289_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123440552422027798260000000469475361503995796_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123440552422027798260000000469475361503995796_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044167898928588033090000007737036427471102137_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123440552422027798260000000469475361503995796_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.2,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000044167898928588033090000007737036427471102137_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183232112411140607920000000929646209592333956_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183232112411140607920000000929646209592333956_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087387942429120472940000005984780193764672391_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183232112411140607920000000929646209592333956_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000087387942429120472940000005984780193764672391_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000049905271218611564790000009349103089385559975_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049905271218611564790000009349103089385559975_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036969141728713643850000010006325566823103361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049905271218611564790000009349103089385559975_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000036969141728713643850000010006325566823103361_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083766995450904607880000010698399029580728465_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083766995450904607880000010698399029580728465_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036211379308059023240000016880562490567909823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083766995450904607880000010698399029580728465_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000036211379308059023240000016880562490567909823_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000138536371293220126210000009727962703035402371_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138536371293220126210000009727962703035402371_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072972480452761844550000002886763793191875985_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138536371293220126210000009727962703035402371_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000072972480452761844550000002886763793191875985_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108304117425167768820000004454013843942875802_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108304117425167768820000004454013843942875802_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016041124150619605700000001321849297005531526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108304117425167768820000004454013843942875802_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.9,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000016041124150619605700000001321849297005531526_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150072173379391482770000001715593198000735674_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150072173379391482770000001715593198000735674_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129197746113408337420000017353523747987023544_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150072173379391482770000001715593198000735674_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.9,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000129197746113408337420000017353523747987023544_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121269176708066926500000008529969865068026803_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121269176708066926500000008529969865068026803_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110438586816332995670000000816111012168704442_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121269176708066926500000008529969865068026803_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.8,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000110438586816332995670000000816111012168704442_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069358182004899215100000004607952629198486658_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069358182004899215100000004607952629198486658_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013193714057024331420000016399389490761895562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069358182004899215100000004607952629198486658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 23.6,
    style: {
      clipPath: "url(#SVGID_00000013193714057024331420000016399389490761895562_)",
      fill: "#116633"
    },
    width: 0.2,
    height: 14.8
  })), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174584068871419781090000011387143573906359956_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174584068871419781090000011387143573906359956_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066489680577114769360000008022929392492981943_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174584068871419781090000011387143573906359956_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000066489680577114769360000008022929392492981943_)",
      fill: "#116633"
    },
    width: 0,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057851694827977374540000011414733345686991494_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057851694827977374540000011414733345686991494_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179616005434855167190000012157034835435402899_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057851694827977374540000011414733345686991494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000179616005434855167190000012157034835435402899_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129925667190712132830000006482546563528805011_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129925667190712132830000006482546563528805011_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013157957810068827910000001230776913207729555_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129925667190712132830000006482546563528805011_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000013157957810068827910000001230776913207729555_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000088841537377270458740000010352305745308388998_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088841537377270458740000010352305745308388998_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067941447879136763360000014210370311145493654_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088841537377270458740000010352305745308388998_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000067941447879136763360000014210370311145493654_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000017482103055914983830000010060922205650608549_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017482103055914983830000010060922205650608549_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171695409419609357750000001596113981878866318_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017482103055914983830000010060922205650608549_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000171695409419609357750000001596113981878866318_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031166622627449210620000012571265223186165175_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031166622627449210620000012571265223186165175_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009590214542235733420000002179291259239374465_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031166622627449210620000012571265223186165175_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000009590214542235733420000002179291259239374465_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000019657017861106647670000014014482397251942321_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019657017861106647670000014014482397251942321_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005954230313058798440000014600316505585445551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019657017861106647670000014014482397251942321_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000005954230313058798440000014600316505585445551_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132795129471965168500000004436310601769651359_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132795129471965168500000004436310601769651359_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129890216700013678190000005391279832290201506_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132795129471965168500000004436310601769651359_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000129890216700013678190000005391279832290201506_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129890727890100556050000013761794825864372667_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129890727890100556050000013761794825864372667_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155110314519637914530000006131940996459095695_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129890727890100556050000013761794825864372667_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000155110314519637914530000006131940996459095695_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106133098191780547810000015240515707256530063_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106133098191780547810000015240515707256530063_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180346280093653262500000015606046214792405645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106133098191780547810000015240515707256530063_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000180346280093653262500000015606046214792405645_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069396463947259314850000017724781692476001207_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069396463947259314850000017724781692476001207_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037676943572618407380000010106447874233573266_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069396463947259314850000017724781692476001207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000037676943572618407380000010106447874233573266_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000028312943053365904070000006390895738537304231_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028312943053365904070000006390895738537304231_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013891173894808706010000006303444035236807071_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028312943053365904070000006390895738537304231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000013891173894808706010000006303444035236807071_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044866273643855334700000003117127122491023038_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044866273643855334700000003117127122491023038_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078754087696072096060000012776720093950312850_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044866273643855334700000003117127122491023038_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000078754087696072096060000012776720093950312850_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000105428731611999878450000003456410055368760223_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105428731611999878450000003456410055368760223_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142857550059777335230000003313451615531409823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105428731611999878450000003456410055368760223_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000142857550059777335230000003313451615531409823_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000033370554375684504970000010983773293336958383_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033370554375684504970000010983773293336958383_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080189118929741433690000013532948418817400223_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033370554375684504970000010983773293336958383_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000080189118929741433690000013532948418817400223_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135649938247131926940000018294160607416962977_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135649938247131926940000018294160607416962977_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033331941970141904210000015391288979965207688_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135649938247131926940000018294160607416962977_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000033331941970141904210000015391288979965207688_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096762806249747904430000014979112004884761229_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096762806249747904430000014979112004884761229_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040549167083562278070000015524802841472861626_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096762806249747904430000014979112004884761229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000040549167083562278070000015524802841472861626_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103266568730559271380000011869162408486950324_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103266568730559271380000011869162408486950324_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001662905014323557730000000241602913720613281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103266568730559271380000011869162408486950324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000001662905014323557730000000241602913720613281_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152947493760641235950000008276226578212470701_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152947493760641235950000008276226578212470701_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159449793412897456010000000435750224173552822_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152947493760641235950000008276226578212470701_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000159449793412897456010000000435750224173552822_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000146498869380709697700000016860047348041581476_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146498869380709697700000016860047348041581476_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165932596130473572420000003495819055996810149_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000146498869380709697700000016860047348041581476_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000165932596130473572420000003495819055996810149_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149366846633545609740000014049546288609574312_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149366846633545609740000014049546288609574312_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026158954868607776460000008389991866906436527_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149366846633545609740000014049546288609574312_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000026158954868607776460000008389991866906436527_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000089565772762090204390000010645157098345673138_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089565772762090204390000010645157098345673138_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148637633681086788600000003199788570469223041_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089565772762090204390000010645157098345673138_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.8,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000148637633681086788600000003199788570469223041_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078762028303346155150000015543130273339201692_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078762028303346155150000015543130273339201692_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035488389526558185280000017934034817711784085_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078762028303346155150000015543130273339201692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000035488389526558185280000017934034817711784085_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054255974027144133470000008796896557215937980_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255974027144133470000008796896557215937980_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071560958308157585780000002959162052100438416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054255974027144133470000008796896557215937980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 45.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000071560958308157585780000002959162052100438416_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041976271195265555210000008041303164004015780_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041976271195265555210000008041303164004015780_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080201540023116052650000015608580029656541347_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041976271195265555210000008041303164004015780_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 46.6,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000080201540023116052650000015608580029656541347_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000176742172456287231970000003700512082795126400_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176742172456287231970000003700512082795126400_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052085951380421198110000006641354353456969915_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176742172456287231970000003700512082795126400_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000052085951380421198110000006641354353456969915_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023986157515837745800000004858898754990972061_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023986157515837745800000004858898754990972061_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022534321885162020470000017729937245101553583_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023986157515837745800000004858898754990972061_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000022534321885162020470000017729937245101553583_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152245500327563668660000000763215447791784601_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152245500327563668660000000763215447791784601_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142174397541058387850000016245526380437583031_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152245500327563668660000000763215447791784601_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000142174397541058387850000016245526380437583031_)",
      fill: "#116633"
    },
    width: 0.9,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139289404118292216620000012564439342487819967_",
    d: "M25,31c0-6.9,5.4-12,12.7-12s12.7,5.1,12.7,12 S45,43,37.7,43S25,37.9,25,31z M44.9,31c0-4.4-3.1-7.4-7.2-7.4s-7.2,3-7.2,7.4s3.1,7.4,7.2,7.4S44.9,35.4,44.9,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139289404118292216620000012564439342487819967_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064346810108765247140000007858217765011833023_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139289404118292216620000012564439342487819967_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000064346810108765247140000007858217765011833023_)",
      fill: "#116633"
    },
    width: 0,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023989045086597640200000016987145077598262186_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023989045086597640200000016987145077598262186_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036933155889276242600000001419048634864420240_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023989045086597640200000016987145077598262186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000036933155889276242600000001419048634864420240_)",
      fill: "#116633"
    },
    width: 0,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128451959322704978940000012345932449027722155_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128451959322704978940000012345932449027722155_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175292517583905893670000007710957249331607208_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128451959322704978940000012345932449027722155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000175292517583905893670000007710957249331607208_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178919170268405309340000017212093975498030229_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178919170268405309340000017212093975498030229_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129924639068390398170000000519233989625635738_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178919170268405309340000017212093975498030229_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000129924639068390398170000000519233989625635738_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050640932524348819450000004718243189111733903_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050640932524348819450000004718243189111733903_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096042738737620004090000004837396937280870532_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050640932524348819450000004718243189111733903_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000096042738737620004090000004837396937280870532_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135658015670048321200000009515707317579601079_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135658015670048321200000009515707317579601079_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166659302405284060300000001728301539773930640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135658015670048321200000009515707317579601079_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000166659302405284060300000001728301539773930640_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099657399091818569070000001694816270063179178_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099657399091818569070000001694816270063179178_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085214137515460214590000007968711298501954961_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099657399091818569070000001694816270063179178_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.3,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000085214137515460214590000007968711298501954961_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000045581954231481515010000017096860726170886044_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045581954231481515010000017096860726170886044_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178891847037575787820000000163864033209444480_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045581954231481515010000017096860726170886044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000178891847037575787820000000163864033209444480_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000149348106222873237770000002486267495788629916_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149348106222873237770000002486267495788629916_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183207454562653193090000013303028754420444840_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149348106222873237770000002486267495788629916_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000183207454562653193090000013303028754420444840_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085209339391072395410000011053943272655704748_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085209339391072395410000011053943272655704748_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118361811362873826480000013017207133974484382_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085209339391072395410000011053943272655704748_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.7,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000118361811362873826480000013017207133974484382_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000171707479887879679990000012371388457127321273_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171707479887879679990000012371388457127321273_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036215187702953449390000004274859460697420428_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171707479887879679990000012371388457127321273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.6,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000036215187702953449390000004274859460697420428_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000109740096120586117690000006911817569942074518_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109740096120586117690000006911817569942074518_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142170467257833377370000007070438325026072735_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000109740096120586117690000006911817569942074518_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000142170467257833377370000007070438325026072735_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158746546315397670360000015766193973259605147_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158746546315397670360000015766193973259605147_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013897760239456234940000018074780884452476093_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158746546315397670360000015766193973259605147_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.2,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000013897760239456234940000018074780884452476093_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000035517166908708215540000005963158217488196226_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035517166908708215540000005963158217488196226_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055704075369408015420000016305640169652064680_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035517166908708215540000005963158217488196226_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000055704075369408015420000016305640169652064680_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000137119338225499654100000010272777112335368584_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137119338225499654100000010272777112335368584_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066512252854406311150000005395565643392493956_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137119338225499654100000010272777112335368584_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000066512252854406311150000005395565643392493956_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114792984206279736440000013253850938830319751_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114792984206279736440000013253850938830319751_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157992435525387934480000009697164620027409551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114792984206279736440000013253850938830319751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000157992435525387934480000009697164620027409551_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124147204218343870150000011800066624553948317_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124147204218343870150000011800066624553948317_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000017506094890909260620000011100846225802705048_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124147204218343870150000011800066624553948317_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000017506094890909260620000011100846225802705048_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134223040054274953890000004294069502936898725_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134223040054274953890000004294069502936898725_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129884061680334484870000018310887512718762129_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134223040054274953890000004294069502936898725_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.4,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000129884061680334484870000018310887512718762129_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116927899034104358120000004692957143608536970_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116927899034104358120000004692957143608536970_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036241551473951518500000009667221804290078861_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116927899034104358120000004692957143608536970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.2,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000036241551473951518500000009667221804290078861_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115500706190707104780000011996697769807877537_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115500706190707104780000011996697769807877537_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008852354946404687390000008247250045791424946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115500706190707104780000011996697769807877537_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000008852354946404687390000008247250045791424946_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178913294875696758750000014821626651930193044_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178913294875696758750000014821626651930193044_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030486921181955668530000008371713448838789291_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178913294875696758750000014821626651930193044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 67.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000030486921181955668530000008371713448838789291_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111896357523234779400000009102047557473968276_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111896357523234779400000009102047557473968276_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010269499099822416080000012119619822713514628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111896357523234779400000009102047557473968276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68.7,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000010269499099822416080000012119619822713514628_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029727951673737713000000017492511344755053708_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029727951673737713000000017492511344755053708_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081642582880010199270000006027910073656931487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029727951673737713000000017492511344755053708_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000081642582880010199270000006027910073656931487_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059280960193490022690000007320719980724891553_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059280960193490022690000007320719980724891553_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165227956878525180200000006622319772126534844_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059280960193490022690000007320719980724891553_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000165227956878525180200000006622319772126534844_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103225809489447788660000013658695577449042108_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103225809489447788660000013658695577449042108_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025423518470036803990000014711653191333340049_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103225809489447788660000013658695577449042108_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000025423518470036803990000014711653191333340049_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021112513106150405990000018019859909040440209_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021112513106150405990000018019859909040440209_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155142973287754513940000005259024748640283536_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021112513106150405990000018019859909040440209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000155142973287754513940000005259024748640283536_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs128 || (_defs128 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101070233891703390010000015207634250901177248_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101070233891703390010000015207634250901177248_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111175968546781728050000017851452924344947080_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101070233891703390010000015207634250901177248_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000111175968546781728050000017851452924344947080_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs129 || (_defs129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163760561499316875380000017414509677774231949_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163760561499316875380000017414509677774231949_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109749042446037589280000018072465723754359719_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163760561499316875380000017414509677774231949_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.7,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000109749042446037589280000018072465723754359719_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs130 || (_defs130 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000153705060225132586240000011127218519264292738_",
    d: "M70,30.6h4.9V40c-2.5,1.9-6,2.9-9.4,2.9 c-7.3,0-12.6-5-12.6-12s5.4-12,12.7-12c4.1,0,7.4,1.4,9.7,4l-3.4,3.2c-1.7-1.8-3.6-2.6-6-2.6c-4.5,0-7.6,3-7.6,7.4 s3.1,7.4,7.5,7.4c1.5,0,2.8-0.3,4.2-1L70,30.6L70,30.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153705060225132586240000011127218519264292738_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147216435669573794640000011906465989597034912_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153705060225132586240000011127218519264292738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 18.9,
    style: {
      clipPath: "url(#SVGID_00000147216435669573794640000011906465989597034912_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs131 || (_defs131 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000078725550695358515290000003952195893726816433_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078725550695358515290000003952195893726816433_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078024921183789461350000007204798884921040020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078725550695358515290000003952195893726816433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.9,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000078024921183789461350000007204798884921040020_)",
      fill: "#116633"
    },
    width: 0.6,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs132 || (_defs132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155105121681295879240000011411150342079042216_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155105121681295879240000011411150342079042216_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000087374902820146145490000016554719276037724847_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155105121681295879240000011411150342079042216_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000087374902820146145490000016554719276037724847_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs133 || (_defs133 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013178207957325810490000013419343022985485225_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013178207957325810490000013419343022985485225_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099637204154138355700000001679807190348378511_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013178207957325810490000013419343022985485225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000099637204154138355700000001679807190348378511_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs134 || (_defs134 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000131353417964850257030000003726941029023072435_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131353417964850257030000003726941029023072435_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083767764293450328770000008508296549234567059_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131353417964850257030000003726941029023072435_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000083767764293450328770000008508296549234567059_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs135 || (_defs135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000099650799040182327850000014411440388663806650_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099650799040182327850000014411440388663806650_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049923188381267907360000003621405121998196153_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099650799040182327850000014411440388663806650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000049923188381267907360000003621405121998196153_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs136 || (_defs136 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000088851683820925194350000007023031422675010479_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088851683820925194350000007023031422675010479_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033369393260287479700000001150806587252876706_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088851683820925194350000007023031422675010479_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000033369393260287479700000001150806587252876706_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs137 || (_defs137 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000150093552343294544380000012138688091377499327_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150093552343294544380000012138688091377499327_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113332093008823457470000008461193546791695015_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150093552343294544380000012138688091377499327_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.9,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000113332093008823457470000008461193546791695015_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs138 || (_defs138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000136383137183289526190000014556896638988811189_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136383137183289526190000014556896638988811189_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161602234886704939500000007709199165184583840_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136383137183289526190000014556896638988811189_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000161602234886704939500000007709199165184583840_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs139 || (_defs139 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000160151264575213057720000013674047441734988431_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160151264575213057720000013674047441734988431_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000155841884670724398080000009011554015381338543_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160151264575213057720000013674047441734988431_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000155841884670724398080000009011554015381338543_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs140 || (_defs140 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000007394623633059335760000011685105588717268897_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007394623633059335760000011685105588717268897_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160903542244810779070000009157256788620658053_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007394623633059335760000011685105588717268897_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000160903542244810779070000009157256788620658053_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs141 || (_defs141 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000138540188034179257540000001005044030367247760_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138540188034179257540000001005044030367247760_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093157359317190841870000008336569459354513299_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138540188034179257540000001005044030367247760_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000093157359317190841870000008336569459354513299_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs142 || (_defs142 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000173128654483340194690000010993502173201971842_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173128654483340194690000010993502173201971842_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103241559592958379160000013727726403873476268_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173128654483340194690000010993502173201971842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 87.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000103241559592958379160000013727726403873476268_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs143 || (_defs143 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000032610069070974718450000003018748865931636362_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032610069070974718450000003018748865931636362_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098934856172883833370000003672139029567945884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032610069070974718450000003018748865931636362_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 87.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000098934856172883833370000003672139029567945884_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs144 || (_defs144 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000043457842377532657260000015624858142114936253_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043457842377532657260000015624858142114936253_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096739095182589277220000013861783320858884241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000043457842377532657260000015624858142114936253_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000096739095182589277220000013861783320858884241_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs145 || (_defs145 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000155139738154380108100000016896448211993281975_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155139738154380108100000016896448211993281975_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080192035749709317190000005896261045611831210_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155139738154380108100000016896448211993281975_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000080192035749709317190000005896261045611831210_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs146 || (_defs146 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000010299103510852070420000004261133487794106754_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010299103510852070420000004261133487794106754_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132802543836733219510000014259575691710569662_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010299103510852070420000004261133487794106754_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000132802543836733219510000014259575691710569662_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs147 || (_defs147 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000084492624102736866830000016647679164883469231_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084492624102736866830000016647679164883469231_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136394865211284964510000001250124498769770171_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084492624102736866830000016647679164883469231_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000136394865211284964510000001250124498769770171_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs148 || (_defs148 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039818151064498141130000010951875941616305074_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039818151064498141130000010951875941616305074_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024704508871325096110000000855959579336931470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039818151064498141130000010951875941616305074_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 91.2,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000024704508871325096110000000855959579336931470_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs149 || (_defs149 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000061441955680267063380000009507568470095063996_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061441955680267063380000009507568470095063996_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039102308635377113650000016984992150031193004_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061441955680267063380000009507568470095063996_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 91.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000039102308635377113650000016984992150031193004_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs150 || (_defs150 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000180358569231479059740000009470547035761011840_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180358569231479059740000009470547035761011840_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115506718039117342350000010906712320682152628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180358569231479059740000009470547035761011840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000115506718039117342350000010906712320682152628_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs151 || (_defs151 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000140732070394089403870000003339930525840117432_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140732070394089403870000003339930525840117432_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049218121003340536420000005639384550099148682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140732070394089403870000003339930525840117432_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000049218121003340536420000005639384550099148682_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs152 || (_defs152 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000021801122836786229190000012712114576307411606_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021801122836786229190000012712114576307411606_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156585714605069322200000016461033422538956454_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021801122836786229190000012712114576307411606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000156585714605069322200000016461033422538956454_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs153 || (_defs153 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000128485197543650577570000011480482114131280822_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128485197543650577570000011480482114131280822_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016787805230595496790000009157519706187539857_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128485197543650577570000011480482114131280822_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000016787805230595496790000009157519706187539857_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs154 || (_defs154 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000103245704613166927850000016753649127357948335_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103245704613166927850000016753649127357948335_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000037687285111529891470000013551095697271435667_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103245704613166927850000016753649127357948335_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.1,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000037687285111529891470000013551095697271435667_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs155 || (_defs155 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013194779698141133540000003822043035597923487_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013194779698141133540000003822043035597923487_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054953740017897809080000006591011273846150838_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013194779698141133540000003822043035597923487_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000054953740017897809080000006591011273846150838_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs156 || (_defs156 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000056427376817224871580000013251738733563419794_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056427376817224871580000013251738733563419794_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006697389124553640690000014731578690490521528_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056427376817224871580000013251738733563419794_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000006697389124553640690000014731578690490521528_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs157 || (_defs157 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000159450676193047950270000004622531933066009477_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159450676193047950270000004622531933066009477_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006690601324585095510000002577892164867804084_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159450676193047950270000004622531933066009477_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000006690601324585095510000002577892164867804084_)",
      fill: "#116633"
    },
    width: 0.7,
    height: 23.2
  })), /*#__PURE__*/React.createElement("g", null, _defs158 || (_defs158 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000104684788915248605210000014288458842484804278_",
    points: "97.8,38.3 97.8,42.6 79.9,42.6 79.9,19.4  97.4,19.4 97.4,23.7 85.2,23.7 85.2,28.7 95.9,28.7 95.9,32.9 85.2,32.9 85.2,38.3 97.8,38.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104684788915248605210000014288458842484804278_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076576134746796692810000010745586386456908959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104684788915248605210000014288458842484804278_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.8,
    y: 19.4,
    style: {
      clipPath: "url(#SVGID_00000076576134746796692810000010745586386456908959_)",
      fill: "#116633"
    },
    width: 0,
    height: 23.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs159 || (_defs159 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152980052869206655030000016618075211205142692_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152980052869206655030000016618075211205142692_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181078521584651636410000007345209049585702065_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152980052869206655030000016618075211205142692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000181078521584651636410000007345209049585702065_)",
      fill: "#116633"
    },
    width: 0,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs160 || (_defs160 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174575880671892989620000015490359580768070021_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174575880671892989620000015490359580768070021_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109021676531315912620000017534873232147186078_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174575880671892989620000015490359580768070021_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000109021676531315912620000017534873232147186078_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs161 || (_defs161 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096767006143606753140000013987796887942038688_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096767006143606753140000013987796887942038688_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109003936560716639510000001914393474019030948_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096767006143606753140000013987796887942038688_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000109003936560716639510000001914393474019030948_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs162 || (_defs162 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168090815760256987690000013336147783283966104_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168090815760256987690000013336147783283966104_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106119067623009241330000008987603462806904733_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168090815760256987690000013336147783283966104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000106119067623009241330000008987603462806904733_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs163 || (_defs163 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000141443952418012974950000016838060431410848904_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141443952418012974950000016838060431410848904_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044872704009620512790000007301008059518127746_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141443952418012974950000016838060431410848904_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000044872704009620512790000007301008059518127746_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs164 || (_defs164 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000035497907205928120310000004730143736472514692_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035497907205928120310000004730143736472514692_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057113044393874107600000011595250350725463437_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035497907205928120310000004730143736472514692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 103.8,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000057113044393874107600000011595250350725463437_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs165 || (_defs165 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029724222071954082010000017364863571355150495_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029724222071954082010000017364863571355150495_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030466970052841785630000018217157814531209098_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029724222071954082010000017364863571355150495_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000030466970052841785630000018217157814531209098_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs166 || (_defs166 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000092454101131871649510000009583193748699639431_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092454101131871649510000009583193748699639431_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004525823904525070790000007249813925927509411_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092454101131871649510000009583193748699639431_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000004525823904525070790000007249813925927509411_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs167 || (_defs167 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054245634402780295330000001559450096439332504_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054245634402780295330000001559450096439332504_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157293083523596416280000015363461200943798427_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054245634402780295330000001559450096439332504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.3,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000157293083523596416280000015363461200943798427_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs168 || (_defs168 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075126677910712880170000001565450733466201535_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075126677910712880170000001565450733466201535_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158733384398547978480000015751451090456501179_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075126677910712880170000001565450733466201535_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000158733384398547978480000015751451090456501179_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs169 || (_defs169 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000027572446744378344790000014819539023888314791_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027572446744378344790000014819539023888314791_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070112383820006833610000008106449675860137090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000027572446744378344790000014819539023888314791_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000070112383820006833610000008106449675860137090_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs170 || (_defs170 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021803312981054598870000003711954185035830689_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021803312981054598870000003711954185035830689_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113346009515307883490000004037709280154825395_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021803312981054598870000003711954185035830689_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000113346009515307883490000004037709280154825395_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs171 || (_defs171 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169524762834741026960000012578773123559641782_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169524762834741026960000012578773123559641782_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127746185735485233230000017633199477545461419_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169524762834741026960000012578773123559641782_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000127746185735485233230000017633199477545461419_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs172 || (_defs172 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096030171417384151140000000848162744218524825_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096030171417384151140000000848162744218524825_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082353584110188351660000002426089156719512463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096030171417384151140000000848162744218524825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.3,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000082353584110188351660000002426089156719512463_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs173 || (_defs173 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000166638381139387148230000002937325225713995922_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166638381139387148230000002937325225713995922_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148618956951223258710000002408874069534338747_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166638381139387148230000002937325225713995922_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000148618956951223258710000002408874069534338747_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs174 || (_defs174 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029015814251347668170000010181029403631242391_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029015814251347668170000010181029403631242391_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171693724833483807800000012798074499379396765_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029015814251347668170000010181029403631242391_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000171693724833483807800000012798074499379396765_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs175 || (_defs175 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013897864136649629110000002167578843213560999_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013897864136649629110000002167578843213560999_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062166619317588351910000004365162450758235063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013897864136649629110000002167578843213560999_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.8,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000062166619317588351910000004365162450758235063_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs176 || (_defs176 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029022503593403151060000014237119881624366483_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029022503593403151060000014237119881624366483_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152949811183752879790000002282120387461752475_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029022503593403151060000014237119881624366483_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.6,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000152949811183752879790000002282120387461752475_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs177 || (_defs177 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085208867371293227610000000466269010843389323_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085208867371293227610000000466269010843389323_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074401780233206878940000015391377714853987492_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085208867371293227610000000466269010843389323_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 114.4,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000074401780233206878940000015391377714853987492_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs178 || (_defs178 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020384121736707412800000010353375842322106300_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020384121736707412800000010353375842322106300_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016785908578003894180000007248383210852279996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020384121736707412800000010353375842322106300_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000016785908578003894180000007248383210852279996_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs179 || (_defs179 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090279415542448353920000004196683335171434375_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090279415542448353920000004196683335171434375_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062882498374291195300000014244079397920413372_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090279415542448353920000004196683335171434375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000062882498374291195300000014244079397920413372_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs180 || (_defs180 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075843037474234026030000000985712089924903553_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075843037474234026030000000985712089924903553_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160883506319703743720000004804990800012844675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075843037474234026030000000985712089924903553_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.9,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000160883506319703743720000004804990800012844675_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs181 || (_defs181 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000066480202067872265440000008495177901769803963_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066480202067872265440000008495177901769803963_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176724649470383981330000000642885627432669101_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066480202067872265440000008495177901769803963_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.7,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000176724649470383981330000000642885627432669101_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs182 || (_defs182 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000167363087465635601440000013728508653382575768_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167363087465635601440000013728508653382575768_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177441859574072782610000002440200416030633602_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167363087465635601440000013728508653382575768_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000177441859574072782610000002440200416030633602_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs183 || (_defs183 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106867580369903421670000000180682831296477574_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106867580369903421670000000180682831296477574_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174581977332323659100000014953147045521904822_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106867580369903421670000000180682831296477574_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.3,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000174581977332323659100000014953147045521904822_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs184 || (_defs184 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131357670933889162340000010361089393235137197_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131357670933889162340000010361089393235137197_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173127117000130101320000002445754298099640236_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131357670933889162340000010361089393235137197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.2,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000173127117000130101320000002445754298099640236_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs185 || (_defs185 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059281772637390216500000009739485836902633392_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059281772637390216500000009739485836902633392_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128466830743387052240000000883026548770153619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059281772637390216500000009739485836902633392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000128466830743387052240000000883026548770153619_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, _defs186 || (_defs186 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000083053389828660662530000014603460837732648370_",
    d: "M100.5,31c0-7,5.4-12,12.6-12c4,0,7.3,1.5,9.5,4.1 l-3.4,3.2c-1.5-1.8-3.5-2.7-5.8-2.7c-4.3,0-7.4,3-7.4,7.4s3.1,7.4,7.4,7.4c2.3,0,4.3-0.9,5.8-2.7l3.4,3.2 c-2.2,2.7-5.5,4.1-9.6,4.1C105.9,42.9,100.5,38,100.5,31z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083053389828660662530000014603460837732648370_",
    style: {
      overflow: "visible",
      fill: "#116633"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144296035071130812340000011508056659428145594_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083053389828660662530000014603460837732648370_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 19,
    style: {
      clipPath: "url(#SVGID_00000144296035071130812340000011508056659428145594_)",
      fill: "#116633"
    },
    width: 0.8,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7843f855fd9c928b6fafb29f95a50a12.svg";
export { ForwardRef as ReactComponent };